module.exports = __webpack_public_path__ + "static/media/get-tickets.076e5220.png";